<section id="section-an-charts-container">

  <!--<span class="an-charts-header">{{chartsConfig.header}}</span>-->

</section>
